import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import WhatsAppTable from './WhatsAppTable';
import whatsAppService from '../../api/whatsAppService';

function WhatsAppScreen({ dispatch, messages }) {
    const [loadingData, setLoadingData] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log('Before API Call');
                const response = await whatsAppService.getWhatsappMessages(null, null, null, null, 1, 10);
                console.log('After API Call:', response.data.items);
                setLoadingData(false);
            } catch (error) {
                console.error('Error fetching WhatsApp messages:', error);
                setLoadingData(false);
            }
        };

        fetchData();
    }, [dispatch]);

    console.log('Component State Messages:', messages);

    return (
        <div>
            {loadingData ? (
                <p>Loading...</p>
            ) : (
                <WhatsAppTable />
            )}
        </div>
    );
}

const mapStateToProps = ({ whatsappState }) => {
    console.log('Mapped Messages:', whatsappState.messages);
    return {
        messages: whatsappState.messages,
    };
};

export default connect(mapStateToProps)(WhatsAppScreen);